function schoonInschrijfUrl() {
  const url = new URL(window.location.href);
  if (!url.searchParams.has('customer_posted')) return;

  url.searchParams.delete('customer_posted');
  const schoon = url.pathname + (url.search === '?' ? '' : url.search);
  history.replaceState(null, '', schoon);
}

function rustBuitenBeeld() {
  const ft = document.querySelector('[data-vt-ft]');
  if (!ft || ft.dataset.vtKijk === '1' || !('IntersectionObserver' in window)) return;
  ft.dataset.vtKijk = '1';
  new IntersectionObserver(([e]) => {
    ft.toggleAttribute('data-vt-rust', !e.isIntersecting);
  }, { rootMargin: '200px 0px' }).observe(ft);
}

rustBuitenBeeld();
schoonInschrijfUrl();
document.addEventListener('shopify:section:load', rustBuitenBeeld);
